import { FilterDropdown } from './fund-finder/filter-dropdown';
import { getFundFinderFilterValue } from './fund-finder/get-fund-finder-filter-value';
import { addAccordionsClickHandlers, setAccordionExpanded } from './accordion';

jQuery(($) => {
    let activeAccordions = [];

    // Keyword filter
    function fundKeywordsField () {
        const delay = (function () {
            let timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        }());

        $('#keywords').keyup((e) => {
            delay(() => {
                const queryStringObject = new URLSearchParams(window.location.search);
                $('#keywords').val() ? $('.clear-keywords-icon').show() : $('.clear-keywords-icon').hide();

                let doFilter = false;

                // Trigger ajax search when character length is more than 3 characters
                if ($('#keywords').val().length >= 3) {
                    doFilter = true;
                    // get all open taxonomy accordions
                    activeAccordions = [];

                    $('.accordion-item.active').each(function (i) {
                        activeAccordions.push($(this).attr('id'));
                    });

                    queryStringObject.set('keywords', $('#keywords').val());
                } else if ($('#keywords').val().length <= 0 && queryStringObject.get('keywords')) {
                    doFilter = true;
                    // delete queryStringObject.keywords;
                    queryStringObject.delete('keywords');
                }

                if (doFilter) {
                    // reset any pagination
                    queryStringObject.delete('start');

                    const queryString = queryStringObject.toString();
                    const url = `${window.location.origin}${window.location.pathname}?${queryString}`;

                    ajaxFunds(url);
                }
            }, 1000);
        });
    }

    // Tag filter
    function fundTags () {
        $('.check-box input').on('click', function (e) {
            const checkbox = $(this);
            const tagId = checkbox.data('value');
            const filterName = checkbox.data('filter');

            const queryStringObject = new URLSearchParams(window.location.search);

            let filterValue = getFundFinderFilterValue(queryStringObject, filterName);

            filterValue = filterValue.filter(item => item !== tagId);

            if (checkbox.prop('checked')) {
                filterValue.push(tagId);
            }

            queryStringObject.set(filterName, JSON.stringify(filterValue));
            queryStringObject.delete('start');

            const queryString = queryStringObject.toString();
            const url = `${window.location.origin}${window.location.pathname}?${queryString}`;

            ajaxFunds(url);
        });
    }

    // clear keywords
    function fundClearKeywords () {
        (function setup () {
            const queryStringObject = new URLSearchParams(window.location.search);

            const isKeywords = queryStringObject.get('keywords');
            if (!isKeywords || !$('#keywords').val()) {
                $('.clear-keywords-icon').hide();
            }
        }());

        $('.clear-keywords-icon').on('click', (e) => {
            e.preventDefault();

            const queryStringObject = new URLSearchParams(window.location.search);

            // get all open taxonomy accordions
            activeAccordions = [];

            $('.accordion-item.active').each((index, element) => {
                activeAccordions.push($(element).attr('id'));
            });

            $('.clear-keywords-icon').hide();
            $('#keywords').val('');

            queryStringObject.delete('keywords');
            queryStringObject.delete('start');

            const queryString = queryStringObject.toString();
            const url = `${window.location.origin}${window.location.pathname}?${queryString}`;

            ajaxFunds(url);
        });
    }

    // clear all filtering
    function fundClearButton () {
        $('.clear-filter').on('click', (e) => {
            e.preventDefault();

            if (!window.location.search) {
                return; // do nothing if no filters
            }

            // close all open taxonomy accordions
            activeAccordions = [];

            $('select#sort').val('');
            $('select#show').val('25');

            ajaxFunds(`${window.location.origin}${window.location.pathname}`);
        });
    }

    // other functions that are used
    function ajaxFunds (newUrl, pushState = true) {
        newUrl = newUrl.replace('++', '+');
        newUrl = newUrl.replace(/\+$/, '');

        $('.ajax-loader').show();
        $('.filter-form input.checkbox').prop('disabled', true);
        $('.ajax-list-holder').hide();

        const loadingAnnouncement = document.createElement('span');
        loadingAnnouncement.setAttribute('class', 'sr-only');
        loadingAnnouncement.setAttribute('role', 'status');
        loadingAnnouncement.textContent = 'Searching, please wait';
        const loadingAnnouncementTimeout = setTimeout(function () { $('.ajax-loader').append(loadingAnnouncement); }, 300);

        $.ajax(newUrl, {
            type: 'GET',
            dataType: 'html',
            success: function (data) {
                $('.ajax-loader').hide();
                $('.all-ajax-list').show();
                $('.pagination').show();

                clearTimeout(loadingAnnouncementTimeout);

                $('.ajax-fund-filtering').replaceWith(data);

                if (pushState) {
                    window.history.pushState(
                        { url: newUrl },
                        document.title,
                        newUrl
                    );
                }

                $('.accordion').accordion({
                    header: '.accordion-header',
                    collapsible: true,
                    heightStyle: 'content',
                    active: false,
                    animate: false
                });

                functionsOnload();
            }
        });
    }

    function expandActiveAccordions () {
        $(activeAccordions).each((i, val) => {
            setAccordionExpanded($(`#${val}`), true);
            $(`#${val}`).children('.accordion-header').attr('tabindex', '0');
        });
    }

    function findActiveAccordions () {
        activeAccordions = [];

        const accordionsElementsToOpen = $('.filter-form input.checkbox:checked').parents('.accordion-item');

        accordionsElementsToOpen.each((_, element) => {
            activeAccordions.push($(element).attr('id'));
        });
    }

    // Data to load on page load from URL
    function fundOnPageLoad () {
        const queryStringObject = new URLSearchParams(window.location.search);

        const keywordsQuery = queryStringObject.get('keywords');

        if (keywordsQuery) {
            $('#keywords').val(keywordsQuery);
        }

        const filterParameterNames = [
            'fund',
            'funding-agreement-type',
            'fund-type',
            'nzqcf-level',
            'organisation-type',
            'programme-and-qualification-type'
        ];

        for (const filterName of filterParameterNames) {
            const filterValues = getFundFinderFilterValue(queryStringObject, filterName);

            for (const filterValue of filterValues) {
                $(`#checkbox-${filterValue}`).prop('checked', true);
            }
        }

        findActiveAccordions();
        expandActiveAccordions();
    }

    function addPaginationClickHandlers () {
        $('ul.pagination a').on('click', function (event) {
            event.preventDefault();

            const href = $(this).attr('href');
            ajaxFunds(window.location.origin + href);
        });
    }

    function functionsOnload () {
        fundTags();
        fundKeywordsField();
        fundOnPageLoad();
        fundClearButton();
        fundClearKeywords();
        addAccordionsClickHandlers();
        addPaginationClickHandlers();
    }

    $(document).ready(() => {
        functionsOnload();

        FilterDropdown.create('select#sort', ajaxFunds);
        FilterDropdown.create('select#show', ajaxFunds);

        addEventListener('popstate', (e) => {
            const url = new URL((e.state !== null) ? e.state.url : window.location.href);
            ajaxFunds(url.href, false);

            const queryStringParams = new URLSearchParams(url.search);

            const previousShowValue = queryStringParams.get('show') || '25';
            const previousSortValue = queryStringParams.get('sort') || '';

            $('select#show').val(previousShowValue);
            $('select#sort').val(previousSortValue);
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/app/fund-finder.js